export const setSnackbarVisibility = (value) => ({
  type: 'EMULATION_SET_SNACKBAR_VISIBILITY',
  value
});

export const setInterceptorsAdded = (value) => ({
  type: 'EMULATION_SET_INTERCEPTORS_ADDED',
  value
});
